<template>
  <div>
    <!-- 搜索部分 -->

    <!-- 主体部分  -->
    <div class="clearfix" style="position: relative">
      <!-- 菜单部分 -->
      <el-card class="clearfix ele-card menu-area">
        <!--  导出 新增  -->
        <div style="display:inline-block">
          <el-button type="success" size="mini" @click="editBenefits(0)">新增</el-button>
        </div>
        <!-- 页码 -->
        <div class="fright">
          <el-pagination
            small
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="search.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
      <!-- table部分 -->
      <el-table :data="tableData"
                border
                stripe
                ref="table"
                class="ele-table table-info-area">

        <el-table-column label="ID" align="center" width="250">
          <template slot-scope="scope">
            {{scope.row.bannerId}}
            <span class="tag is-success" v-if="scope.row.statusTag==0">开放中</span>
            <span class="tag is-black" v-if="scope.row.statusTag==1">未开始</span>
            <span class="tag is-light" v-if="scope.row.statusTag==2">已结束</span>
            <span class="tag is-light" v-if="scope.row.statusTag==3">已关闭</span>
          </template>
        </el-table-column>

        <el-table-column label="图片" align="center" width="250">
          <template slot-scope="scope">
            <image-component :image="scope.row.image.image" width="200"></image-component>
          </template>
        </el-table-column>

        <el-table-column label="标题以及访问量" align="center">
          <template slot-scope="scope">
            <p>标题：{{ scope.row.title }}</p>
            <p v-if="scope.row.clickCount">访问量：{{scope.row.clickCount}}</p>
          </template>
        </el-table-column>

        <el-table-column prop="showCount" label="展示数" align="center" ></el-table-column>

        <el-table-column prop="clickCount" label="点击数" align="center" ></el-table-column>

        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.startTime }} ~ {{ scope.row.endTime }}</p>
          </template>
        </el-table-column>

        <el-table-column label="排序号" align="center" width="200px">
          <template slot-scope="scope">排序号
            <el-input style="width: 100px;" size="mini" v-model="scope.row.sort" @change="sortChange(scope.row.sort,scope.row.bannerId)"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <p class="a-button">
              <a class="" @click="editBenefits(scope.row.bannerId)">编辑</a>
              <a class="a-red" @click="onDelete(scope.row.bannerId)">删除</a>
            </p>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        search: {
          page: 1,
          pageSize: 20
        },
        total: 0,
        tableData: [],
      };
    },
    mounted(){
      this.search.page = parseInt(this.$route.query.page) || 1
      this.search.pageSize = parseInt(this.$route.query.pageSize) || 20
      this.getAdvList();
    },
    methods:{
      // 翻页
      handleCurrentChange(page) {
        if (this.search.page !== page) {
          this.search.page = page;
          this.getAdvList();
          window.scrollTo(0, 0);
        }
      },
      // 改变页数
      handleSizeChange(pageSize) {
        this.search.pageSize = pageSize;
        this.getAdvList();
        window.scrollTo(0, 0);
      },
      // 获取广告位列表
      getAdvList() {
        let params = {
          page:this.search.page,
          pageSize:this.search.pageSize,
        }
          HttpRequest.get("/admin.php?method=main.getAdvList", params).then((response) => {
           this.tableData = response.data.list;
           this.total = parseInt(response.data.count);
         });
      },
      // 删除
      onDelete(bannerId) {
        this.$confirm('是否删除预告', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            bannerId: bannerId
          }
          HttpRequest.get("/admin.php?method=main.removeAdv", params).then((response) => {
            if (response.data.success) {
              this.getAdvList()
            } else {
              this.$message.error(response.msg);
            }
          });
        }).catch(() => {});
      },
      // 新增/编辑预告
      editBenefits(bannerId) {
        // 有id则路由传参
        if (bannerId != 0) {
          this.$router.push({
            name: 'editIndexPopAd',
            query: {
              page: this.search.page,
              pageSize: this.search.pageSize,
              bannerId: bannerId,
            }
          })
        } else {
          this.$router.push({
            name: 'editIndexPopAd',
            query: {
              page: this.search.page,
              pageSize: this.search.pageSize
            }
          })
        }
      },
      sortChange(sort,bannerId) {
        let params = {
            sort: sort,
            bannerId:bannerId,
        }
        HttpRequest.get("/admin.php?method=main.setAdvSort", params).then((response) => {
          if (response.data.success) {
            this.$message('保存成功');
          }else{
            this.$message(response.data.msg)
          }
        })
      },
    }
  };
</script>

<style lang="less" scoped>
  .dialogImg {
    text-align: center;
  }
  .control {
    margin-bottom: 0;
  }
  .tag{
    display: inline-block;
    align-items: center;
    color: #69707a;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    border-radius: 12px;
  }
  .is-success{
    background-color: #97cd76;
    color: #fff;
  }
  .is-black{
    background-color: #000000;
    color: #fff;
  }
  .is-light{
    background-color: #f5f7fa;
    color: #69707a;
  }
</style>
